import { useRef, useState } from "react";

export function useInitializeTrustPilot() {
  const [isTrustPilotInitialized, setIsTrustPilotInitialized] = useState(false);
  const trustPilotWidgetRef = useRef<HTMLDivElement>(null);

  if (
    !isTrustPilotInitialized &&
    trustPilotWidgetRef.current &&
    window.Trustpilot
  ) {
    window.Trustpilot.loadFromElement(trustPilotWidgetRef.current, true);
    setIsTrustPilotInitialized(true);
  }
  return trustPilotWidgetRef;
}
